export default{
    en:{
        // ExpertAccount 11
        'Bienvenue!' : 'Welcome!',
        'Prêt pour votre prochaine mission ? ' : 'Ready for your next project?',
        'Nous vous invitons à compléter votre profil afin de pouvoir activer votre compte et bénéficier de toutes les fonctionnalités offertes par la plateforme.' : 'We invite you to complete your profile to activate your account and to access all platform features',
        'Profil' : 'Profile',
        'Données CV' : 'Perfect your CV',
        'Préférences' : 'Preferences',
        'Société' : 'Company',
        'Commencer' : 'Start',
        'Remplir plus tard' : 'Complete later',
        'Trouvez votre entreprise et rejoignez la':'Find your company and join it',
        'Etes vous une nouvelle entreprise sur la plateforme ?':'Are you a new company on the platform ?',
        'Dites-nous plus sur vous!' : 'Tell us more about you!',
        'Votre intitulé du poste' : 'Your job title',
        'Téléphone (facultatif) ' : 'Phone number(optional)',
        'Synthèse de votre profil (Recommandé) ' : 'Profile summary(Recommended)',
        // 'Données CV' : 'Perfect your CV',
        'Téléchargez votre CV pour permettre aux recruteurs de vous trouver facilement. ' : 'Upload your resume to make it easy for recruiters to find you.',
        'Choisir un fichier' : 'Choose a file',
        'Il est très recommandé de remplir tous les champs pour augmenter la visibilité de votre CV' : 'It is highly recommended to fill in all the fields to increase the visibility of your CV',
        'Etudes et Diplômes' : 'Education',
        'Ajouter un diplôme' : 'Add a  qualification',
        'Ajouter une HNO':'Add NWH',
        'Ajouter une note de frais':'Add an expense claim',
        'Taux journalier/Client':'Daily rate/Customer',
        'Montant total HT/client':'Total amount excl. tax/customer',
        'Taux journalier/Expert':'Daily rate/Expert',
        'Montant total HT/Expert':'Total amount excl. tax/Expert',

        'Expériences' : 'Work experience',
        'Ajouter une expérience' : 'Add work experience',
        'Compétences' : 'Skills',
        'Techniques ? ' : 'Technical skills ?',
        'Compétence' : 'Skill',
        'Débutant':'Beginner',
        'Avancé':'Advanced',
        'Expert':'Expert',
        'Nombre d\'années' : 'Number of years',
        'Plus récente expérience':'Most recent project',
        'Cette année':'This year',
        '1 à 2 ans':'1 to 2 years',
        'Plus de 2 ans':'More than 2 years',
        'Expérience totale':'Total experience',
        // 'Ajouter une expérience' : 'Add Project',
        'Mission et responsabilités' : 'Poject responsibilities',
        'Intitulé du poste' : 'Job Title',
        'Type de contrat' : 'Contract type',
        'Description' :'Description',
        'Nom d\'entreprise' : 'Company Name',
        'Jusqu\'à aujourd\'hui' : 'Up today ',
        'Ajouter des études' : 'Add studies',
        'Nom du diplôme ' : 'Degree title',
        'Université' : 'University',
        'Nom de l\'école *' : 'School Name *',
        'Durée  Du  au' : 'Periodfrom  to',
        'Diplôme en cours' : 'Studies in progress',
        'Formation et Certificats' : 'Training and Certificates',
        'Qualification' : 'Qualification',
        'Année' : 'Year',
        'Ajouter une formation ou certificat' : 'Add training or certificate',
        'débutant': 'beginner',
        'Professionnel':'proficient',
        // 'Avancé':'advanced',
        'Courant':'Fluent',
        'Ajouter une langue' : 'Add a language',
        'Retour' : 'Back',
        'Supprimer cette entrée' : 'Delete This entry',
        'Annuler' : 'Cancel',
        // 'Préférences' : 'Preferences',
        'Intitulé de poste' : 'Job title',
        '3 nombres d\'entrées maximum' : 'Maximum of 3 entries',
        'Type de travail' : 'Job type',
        'Présentiel':'On-site',
        'à distance':'Remote',
        'Hybride':'Hybrid',
        'Indifférent':'Neutral',
        'Temps partiel': 'Part-time',
        'Temps plein':'Full-time',
        'Si temps partiel, nombre de jours' : 'If part-time, number of days',
        'Date de disponibilité':'Availability',

        'Immédiate':'Immediate',

        'Mobilité professionnelle' : 'Are you able to travel at work ?',
        'Mobilité' : 'Mobility',
        'Pays' : 'Country',
        'Région':'Region',
        'Ville' : 'City',
        'Ajouter' : 'Add',
        'Rémunération' : 'Salary',
        'Taux journalier moyen' : 'Average Daily Wage',
        'Salaire mensuel moyen' : 'Average Monthly Salary',
        'Secteur d\'activité (facultatif) ' : 'Industry (optional)',
        'C\'est presque terminé!' : 'It\'s Almost over!',
        // 'Société' : 'Company',
        'Adresse du siège social' : 'Head office address',
        'Numéro d\'immatriculation' : 'Registration number',
        'Numéro TVA intracommunautaire' : 'VAT Number',
        'Numéro de TVA' :'VAT Number',
        'Coordonnées bancaires' :'Bank details',
        'Nom de la banque' :'Bank name',
        'IBAN' :'IBAN',
        'BIC/SWIFT':'BIC/SWIFT',
        // 'Choisir un fichier' :'Select a file',
        'Ou faites-le glisser et déposez-le ici' :'Or drag and drop it here',
        'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)' :'pdf, .doc, .docx, .rtf, .txt (Maximum File size : 5 MB)',
        'Télécharger le RIB' : 'Download Bank details',

        // Expert Compte / doc administratifs 14
        'Pièce d\'identité' : 'ID',
        // 'Pays' : 'Country',
        'Sélectionnez votre pays' :'Select your country',
        'Type de doc.' :'doc type',
        'Sélectionnez le type du document' :'Select your doc type',
        'Carte d\'identité' :'ID',
        'Passeport' :'Passport',
        'Téléchargez votre carte d\'identité' :'Download your identity card',
        'Téléchargez le recto' :'Download the front',
        'Téléchargez le verso' :'Download the back',
        'JPEG ou PNG uniquement' :'JPEG or PNG only',
        'Sauvegarder' :'Save',
        'Kibs' :'Kibs',
        'La prochaine mise à jour de ce document devra être faite avant le' :'This document must be updated before',
        'Télécharger le Kbis' :'Download Kbis',
        // 'Choisir un fichier' :'Select a file',
        // 'Ou faites-le glisser et déposez-le ici' :'Or drag and drop it here',
        // 'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)' :'pdf, .doc, .docx, .rtf, .txt (Maximum File size : 5 MB)',
        'Date de l\'extrait Kbis' :'Date of Kbis extract',
        'Date de l\'extrait':'Extract date',
        'N° SIREN' :'SIREN Number',
        'Valider' :'Confirm',
        // 'Date de l\'extrait Kbis' :'Date of Kbis extract',
        'Date de validité du Kbis' :'Kbis validity date',
        'Date de validité':'Validity date',
        'Téléchargé par': 'Downloaded by',
        'N°SIREN' :'SIREN Number',
        'Ancienneté de l\'extrait' :'Extract age',
        'Nom de la Société' :'Company Name',
        'Validé' :'Confirmed',
        'Supprimer' :'Delete',
        'Attestation fiscale' :'Tax receipt',
        'Télécharger l\'attestation fiscale' :'Download Tax receipt',
        // 'Choisir un fichier' :'Select a file',
        // 'Ou faites-le glisser et déposez-le ici' :'Or drag and drop it here',
        // 'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)' :'pdf, .doc, .docx, .rtf, .txt (Maximum File size : 5 MB)',
        'Date de délivrance' :'Issue date',
        'Date de délivrance de l\'attestation fiscale :' :'issue date of the tax receipt',
        'Date de validité de l\'attestation fiscale :' :'Tax receipt validity date',
        // 'Téléchargé par' :'Downloaded by',
        // 'N°SIREN' :'SIREN Number',
        'Ancienneté de l\'attestation fiscale' :'Tax receipt age',
        // 'Nom de la Société' :'Company Name',
        // 'Validé' :'Confirmed',
        'Non validé' :'Not confirmed',
        'Attestation Urssaf' :'URSSAF certificate',
        'Votre document a expiré, veuillez le mettre à jour' :'Your document has expired, please update',
        'Télécharger l\'attestation Urssaf' :'Download Urssaf certificate',
        'Code de sécurité' :'Safety code',
        'Date de l\'attestation Urssaf:' :'URSSAF certificate date:',
        'Date de validité de l\'attestation Urssaf:' :'Urssaf certificate validity date:',
        'Ancienneté de l\'attestation Urssaf :' : 'Age of Urssaf certificate:',
        'Attestation sur l\'honneur' :'Sworn statement',
        'Conditions de services' :'Service Terms',
        'Signer' :'Sign',
    },
    fr:{
        'Bienvenue!' : 'Bienvenue!',
        'Prêt pour votre prochaine mission ? ' : 'Prêt pour votre prochaine mission ? ',
        'Nous vous invitons à compléter votre profil afin de pouvoir activer votre compte et bénéficier de toutes les fonctionnalités offertes par la plateforme.' : 'Nous vous invitons à compléter votre profil afin de pouvoir activer votre compte et bénéficier de toutes les fonctionnalités offertes par la plateforme.',
        'Profil':'Profil',
        'Données CV': 'Données CV',
        'Préférences' : 'Préférences',
        'Société' : 'Société',
        'Commencer' : 'Commencer',
        'Remplir plus tard' : 'Remplir plus tard',
        'Trouvez votre entreprise et rejoignez la':'Trouvez votre entreprise et rejoignez la',
        'Etes vous une nouvelle entreprise sur la plateforme ?':'Etes vous une nouvelle entreprise sur la plateforme ?',
        'Dites-nous plus sur vous!' : 'Dites-nous plus sur vous!',
        'Votre intitulé du poste' : 'Votre intitulé du poste',
        'Téléphone (facultatif) ' : 'Téléphone (facultatif) ',
        'Synthèse de votre profil (Recommandé) ' : 'Synthèse de votre profil (Recommandé) ',
        // 'Données CV' : 'Données CV',
        'Téléchargez votre CV pour permettre aux recruteurs de vous trouver facilement. ' : 'Téléchargez votre CV pour permettre aux recruteurs de vous trouver facilement. ',
        'Choisir un fichier' : 'Choisir un fichier',
        'Il est très recommandé de remplir tous les champs pour augmenter la visibilité de votre CV' : 'Il est très recommandé de remplir tous les champs pour augmenter la visibilité de votre CV',
        'Etudes et Diplômes' : 'Etudes et Diplômes',
        'Ajouter un diplôme' : 'Ajouter un diplôme',
        'Ajouter une HNO':'Ajouter une HNO',
        'Taux journalier/Client':'Taux journalier/Client',
        'Montant total HT/client':'Montant total HT/client',
        'Taux journalier/Expert':'Taux journalier/Expert',
        'Montant total HT/Expert':'Montant total HT/Expert',

        'Ajouter une note de frais':'Ajouter une note de frais',
        'Expériences' : 'Expériences',
        'Ajouter une expérience' : ' Ajouter une expérience',
        'Compétences' : 'Compétences',
        'Techniques ? ' : 'Techniques ? ',
        'Compétence' : 'Compétences',
        'Niveau': 'Niveau',
        'Débutant':'Débutant',
        'Avancé':'Avancé',
        'Expert':'Expert',
        'Nombre d\'années' : 'Nombre d\'années',
        'Plus récente expérience':'Plus récente expérience',
        'Cette année':'Cette année',
        '1 à 2 ans':'1 à 2 ans',
        'ans':'ans',
        'Plus de 2 ans':'Plus de 2 ans',
        'Expérience totale':'Expérience totale',
        // 'Ajouter une expérience' : 'Ajouter une expérience',
        'Mission et responsabilités' : 'Mission et responsabilités',
        'Intitulé du poste' : 'Intitulé du poste',
        'Type de contrat' : 'Type de contrat',
        'Description' :'Description',
        'Nom d\'entreprise' : 'Nom d\'entreprise',
        'Jusqu\'à aujourd\'hui' : 'Jusqu\'à aujourd\'hui',
        'Ajouter des études' : 'Ajouter des études',
        'Nom du diplôme ' : 'Nom du diplôme ',
        'Université' : 'Université',
        'Nom de l\'école *' : 'Nom de l\'école *',
        'Durée  Du  au' : 'Durée  Du  au',
        'Diplôme en cours' : 'Diplôme en cours',
        'Formation et Certificats' : 'Formation et Certificats',
        'Qualification' : 'Qualification',
        'Année' : 'Année',
        'Ajouter une formation ou certificat' : 'Ajouter une formation ou certificat',
        'débutant': 'débutant',
        'Professionnel':'Professionnel',
        // 'Avancé':'Avancé',
        'Courant':'Courant',
        'Ajouter une langue' : 'Ajouter une langue',
        'Retour' : 'Retour',
        'Supprimer cette entrée' : 'Supprimer cette entrée',
        'Annuler' : 'Annuler',
        // 'Préférences' : 'Préférences',
        'Intitulé de poste' : 'Intitulé de poste',
        '3 nombres d\'entrées maximum' : '3 nombres d\'entrées maximum',
        'Type de travail' : 'Type de travail',
        'Présentiel': 'Présentiel',
        'à distance':'à distance',
        'Hybride':'Hybride',
        'Indifférent':'Indifférent',
        'Temps partiel': 'Temps partiel',
        'Temps plein':'Temps plein',
        'Si temps partiel, nombre de jours' : 'Si temps partiel, nombre de jours',
        'Date de disponibilité':'Date de disponibilité',
        'Immédiate':'Immédiate',

        'Mobilité professionnelle' : 'Mobilité professionnelle',
        'Mobilité' : 'Mobilité',
        'Pays' : 'Pays',
        'Région':'Région',
        'Ville' : 'Ville',
        'Ajouter' : 'Ajouter',
        'Rémunération' : 'Rémunération',
        'Taux journalier moyen' : 'Taux journalier moyen',
        'Salaire mensuel moyen' : 'Salaire mensuel moyen',
        'Secteur d\'activité (facultatif) ' : 'Secteur d\'activité (facultatif) ',
        'C\'est presque terminé! ' : 'C\'est presque terminé ! ',
        // 'Société' : 'Société',
        'Adresse du siège social' : 'Adresse du siège social',
        'Numéro d\'immatriculation' : 'Numéro d\'immatriculation',
        'Numéro TVA intracommunautaire' : 'Numéro TVA intracommunautaire',
        'Profil personnel' : 'Profil personnel',
        'Numéro de TVA' :'Numéro de TVA',
        'Coordonnées bancaires' :'Coordonnées bancaires',
        'Nom de la banque' :'Nom de la banque',
        'IBAN' :'IBAN',
        'BIC/SWIFT':'BIC/SWIFT',
        // 'Choisir un fichier' :'Choisir un fichier',
        'Ou faites-le glisser et déposez-le ici' :'Ou faites-le glisser et déposez-le ici',
        'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)' :'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)',
        'Télécharger le RIB' : 'Télécharger le RIB',

        // Expert Compte / doc administratifs 14
        'Pièce d\'identité' : 'Pièce d\'identité',
        // 'Pays' : 'Pays',
        'Sélectionnez votre pays' :'Sélectionnez votre pays',
        'Type de doc.' :'Type de doc.',
        'Sélectionnez le type du document' :'Sélectionnez le type du document',
        'Carte d\'identité' :'Carte d\'identité',
        'Passeport' :'Passeport',
        'Téléchargez votre carte d\'identité' :'Téléchargez votre carte d\'identité',
        'Téléchargez le recto' :'Téléchargez le recto',
        'Téléchargez le verso' :'Téléchargez le verso',
        'JPEG ou PNG uniquement' :'JPEG ou PNG uniquement',
        'Sauvegarder' :'Sauvegarder',
        'Kibs' :'Kibs',
        'La prochaine mise à jour de ce document devra être faite avant le' :'La prochaine mise à jour de ce document devra être faite avant le',
        'Télécharger le Kbis' :'Télécharger le Kbis',
        // 'Choisir un fichier' :'Choisir un fichier',
        // 'Ou faites-le glisser et déposez-le ici' :'Ou faites-le glisser et déposez-le ici',
        // 'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)' :'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)',
        'Date de l\'extrait Kbis' :'Date de l\'extrait Kbis',
        'Date de l\'extrait':'Date de l\'extrait',
        'N° SIREN' :'N° SIREN',
        'Valider' :'Valider',
        // 'Date de l\'extrait Kbis' :'Date de l\'extrait Kbis',
        'Date de validité du Kbis' :'Date de validité du Kbis',
        'Date de validité':'Date de validité',
        'Téléchargé par' :'Téléchargé par',
        'N°SIREN' :'N°SIREN',
        'Ancienneté de l\'extrait' :'Ancienneté de l\'extrait',
        'Nom de la Société' :'Nom de la Société',
        'Validé' :'Validé',
        'Supprimer' :'Supprimer',
        'Attestation fiscale' :'Attestation fiscale',
        'Télécharger l\'attestation fiscale' :'Télécharger l\'attestation fiscale',
        // 'Choisir un fichier' :'Choisir un fichier',
        // 'Ou faites-le glisser et déposez-le ici' :'Ou faites-le glisser et déposez-le ici',
        // 'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)' :'pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)',
        'Date de délivrance' :'Date de délivrance',
        'Date de délivrance de l\'attestation fiscale :' :'Date de délivrance de l\'attestation fiscale',
        'Date de validité de l\'attestation fiscale :' :'Date de validité de l\'attestation fiscale',
        // 'Téléchargé par' :'Téléchargé par',
        // 'N°SIREN' :'N°SIREN',
        'Ancienneté de l\'attestation fiscale' :'Ancienneté de l\'attestation fiscale',
        // 'Nom de la Société' :'Nom de la Société',
        // 'Validé' :'Validé',
        'Non validé' :'Non validé',
        'Attestation Urssaf' :'Attestation Urssaf',
        'Votre document a expiré, veuillez le mettre à jour' :'Votre document a expiré, veuillez le mettre à jour',
        'Télécharger l\'attestation Urssaf' :'Télécharger l\'attestation Urssaf',
        'Code de sécurité' :'Code de sécurité',
        'Date de l\'attestation Urssaf:' :'Date de l\'attestation Urssaf:',
        'Date de validité de l\'attestation Urssaf:' :'Date de validité de l\'attestation Urssaf:',
        'Ancienneté de l\'attestation Urssaf :' : 'Ancienneté de l\'attestation Urssaf :',
        'Attestation sur l\'honneur' :'Attestation sur l\'honneur',
        'Conditions de services' :'Conditions de services',
        'Signer' :'Signer',
    }
};